import { JsonConvertableImpl, BpmnModelJsonHelper } from '@edp-bif/common-api';
import { RtShowEntitiesWithCustomization } from './RtShowEntitiesWithCustomization';

export class RtBillProcessListResult extends JsonConvertableImpl {
    totalCount: number;
    pageCount: number;
    pageIndex: number;
    pageSize: number;

    entities: Array<RtShowEntitiesWithCustomization> = new Array();

    protected ResetBeforeLoadFrom(): void {
        super.ResetBeforeLoadFrom();

        this.totalCount = 0;
        this.pageCount = 0;
        this.pageIndex = 0;
        this.pageSize = 0;
        this.entities.length = 0;
    }

    public ConvertToJsonObject(): {} {
        let obj = super.ConvertToJsonObject();

        BpmnModelJsonHelper.SetAttributeValue(obj, "totalCount", this.totalCount);
        BpmnModelJsonHelper.SetAttributeValue(obj, "pageCount", this.pageCount);
        BpmnModelJsonHelper.SetAttributeValue(obj, "pageIndex", this.pageIndex);
        BpmnModelJsonHelper.SetAttributeValue(obj, "pageSize", this.pageSize);
        BpmnModelJsonHelper.SetAttributeValue(obj, "entities", this.entities);

        return obj;
    }

    public LoadFromJsonObject(obj: {}): void {
        super.LoadFromJsonObject(obj);

        this.totalCount = BpmnModelJsonHelper.GetAttributeValueAsNumber(obj, "totalCount");
        this.pageCount = BpmnModelJsonHelper.GetAttributeValueAsNumber(obj, "pageCount");
        this.pageIndex = BpmnModelJsonHelper.GetAttributeValueAsNumber(obj, "pageIndex");
        this.pageSize = BpmnModelJsonHelper.GetAttributeValueAsNumber(obj, "pageSize");
        this.entities = BpmnModelJsonHelper.GetAttributeValueAsList(obj, "entities", RtShowEntitiesWithCustomization);
    }
}